import React, { useState, useRef, useEffect } from "react";
//import { Link } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import { useHistory }  from 'react-router-dom';
function ContentsContainer() {
	const history = useHistory();
	const [showRowCnt,setShowRowCnt] = useState(1); //기본 row count
	const [TOTALCNT, setTOTALCNT] = useState(0);	
	//const [StartDate, setStartDate] = useState(new Date());
  	const [StartDate, setStartDate] = useState(() => {
    	const currentYear = new Date().getFullYear();
    	return new Date(currentYear, 0, 1);
  	});
	
	const [EndDate, setEndDate] = useState(new Date());
	const [PAY_CALL_TITLE, setPAY_CALL_TITLE] = useState('');
	
    let totalCnt_dev;
    let SheetData = {};
	let defaultRowCnt = 20;
	let rowCnt = useRef<number>(20);
		
	var ib = {
		//시트 초기화 구문
		'init':{
				
			"Cfg": {
				/*
	            "SearchMode": 0,
	            "SectionCanResize": 1,
	            "CanSort": false,
	            "CanColMove": false,
	            "CanColResize": false,
	            "HeaderCheck": 0,
	            "CanEdit": 0,
	            "Hover": 0,
	            "Height": 500,
	            "PageLength": 20,
	            "InfoRowConfig": {
	                "Visible": false
	            },
	            */   
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"			   
				         		
			},
	
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",			"Type": "Int",	"Name": "SEQ",				"RelWidth": 1,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "지급신청안내년도",	"Type": "Text",	"Name": "PAY_CALL_YYYY",	"RelWidth": 3,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "제목",			"Type": "Text",	"Name": "PAY_CALL_TITLE",	"RelWidth": 3,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "등록일자",			"Type": "Text",	"Name": "REG_DATE",			"RelWidth": 3,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "MODI_SEQ",		"Type": "Text",	"Name": "MODI_SEQ",			"RelWidth": 1, 	Visible : 0}, //지급신청번호
	            {"Header": "BIZ_CD",		"Type": "Text",	"Name": "BIZ_CD",			"RelWidth": 1, 	Visible : 0}, //결재등록일자
	            
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch();
				
			},
			//시트 더블클릭시 이벤트 처리
			onDblClick:function(evtParam){
				onClickDetail();
		    },	
			
			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		        //@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
				
			},			

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'tb_cfms_pay_call', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터
				
			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.exportData({fileName: "지급신청안내관리_"+today+".xlsx"});
		},

	}

   async function onClickSearch() {
		const response:any = await CommonUtil.execute({
            url:"adm_1400_r001",
            data: {
				"ST_DATE" : DateUtil.toDateFormat(StartDate, "YYYYMMDD"),
				"EN_DATE" : DateUtil.toDateFormat(EndDate, "YYYYMMDD"),
				"PAY_CALL_TITLE" : PAY_CALL_TITLE,
			}
        })
    	.then((response: any) => {
			totalCnt_dev = String(Object.keys(response.REC).length);
			setTOTALCNT(totalCnt_dev);
	
			if(typeof response.REC == 'undefined'){
				alert('data is not loaded!!!')
				return;
			}
			
			SheetData = response.REC;
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        Main_sheet.loadSearchData(SheetData);
	        // @ts-ignore
	        makePageIndex(Main_sheet.getPageIndex( Main_sheet.getFocusedPage()) + 1); // 페이지 초기화
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	         
        		
	}


    async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }

    
    async function onClickRegist() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1401',
	      state: { data: dataToSend }
	    });

    };       
    		
    		
    async function onClickDetail() {
        // @ts-ignore
		var row = Main_sheet.getFocusedRow();
		var vPAY_CALL_YYYY = row["PAY_CALL_YYYY"];
		var vMODI_SEQ = row["MODI_SEQ"];
		var vBIZ_CD = row["BIZ_CD"];
        
	    let dataToSend = {
			vPAY_CALL_YYYY,
			vMODI_SEQ,
			vBIZ_CD
		};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1402',
	      state: { data: dataToSend }
	    });

    };      
    

	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt_dev // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; 
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
	}    
    
    
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch();
		}
	}

	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			rowCnt.current = e.target.value;
		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}
	};
	        		
	useEffect(() => {
		//StartDate.setDate(StartDate.getDate() - 1825);
        // @ts-egnore
		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }		

    },[])	
    		
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급신청안내관리</h1>
					{/*<form className="sf sf-1row sf-3col mb30"> {/* [M.20240522] */}
					<div className="sf sf-2col"> 
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">등록일자</p>
								<div className="sf-value">
									<div className="hz-root hz-gap5">
										<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
										<span className="hz-item">~</span>
										<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">제목</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_CALL_TITLE} placeholder={'제목을 입력하세요'} valueChanged={(value) => setPAY_CALL_TITLE(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
						
					</div>
					<div className="hz-root hz-center mb30">
						<button className="bt" data-color="pri" data-size="md" type="button" onClick={onClickSearch}>조회</button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{TOTALCNT}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="pri-o" size="sm" onClick={onClickRegist}>등록</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>

					<div className="ibsheet" id='tb_cfms_pay_call'></div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;